export default {
  absoluteY: 1907,
  absoluteX: 76,
  boxes: [
    {
      type: "primaryBox",
      x: 471,
      y: 213,
      strokeColor: "lime5",
      hoverColor: "lime0",
      text: "User Interface",
    },
    {
      type: "multiBox",
      x: 0,
      y: 0,
      width: 207,
      height: 243,
      fillColor: "lime0",
      text: "Fundamentals",
    },
    {
      type: "multiBox",
      x: 0,
      y: 290,
      width: 207,
      height: 153,
      fillColor: "lime0",
      text: "Component Library",
    },
    {
      type: "multiBox",
      x: 0,
      y: 489,
      width: 207,
      height: 153,
      fillColor: "lime0",
      text: "Design Guidelines",
    },
    {
      type: "multiBox",
      x: 274,
      y: 489,
      width: 207,
      height: 153,
      fillColor: "lime0",
      text: "Interactions",
    },
    {
      type: "multiBox",
      x: 624,
      y: 489,
      width: 207,
      height: 153,
      fillColor: "lime0",
      text: "Web Design",
    },
    {
      type: "multiBox",
      x: 921,
      y: 0,
      width: 207,
      height: 153,
      fillColor: "lime0",
      text: "Usability",
    },
    {
      type: "multiBox",
      x: 921,
      y: 200,
      width: 207,
      height: 198,
      fillColor: "lime0",
      text: "Accessibility",
    },
    {
      type: "multiBox",
      x: 921,
      y: 444,
      width: 207,
      height: 198,
      fillColor: "lime0",
      text: "Mobile Design",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 57,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Color Palette",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 102,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Typography",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 147,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Grids & Spacings",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 192,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Iconography",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 347,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Components",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 392,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "UI Patterns",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 546,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Design Principles",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 16,
      y: 591,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Documentation",
      hoverColor: "lime1",
    },

    {
      type: "tertiaryBox",
      x: 290,
      y: 546,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "UI Animation",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 290,
      y: 591,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Micro-interactions",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 640,
      y: 546,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "HTML & CSS",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 640,
      y: 591,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Responsive Layouts",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 57,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Usability Principles",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 102,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Usability Issues",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 257,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Accessible Design",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 302,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Inclusive Design",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 347,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Tools & Checklist",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 501,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Mobile App Design",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 546,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "iOS & Android",
      hoverColor: "lime1",
    },
    {
      type: "tertiaryBox",
      x: 937,
      y: 591,
      width: 175,
      fillColor: "lime0",
      strokeColor: "lime3",
      text: "Mobile UI Patterns",
      hoverColor: "lime1",
    },
    {
      type: "secondaryBox",
      x: 289,
      y: 141,
      width: 152,
      fillColor: "lime0",
      strokeColor: "lime4",
      text: "Design Handoff",
      hoverColor: "lime1",
    },
    {
      type: "secondaryBox",
      x: 688,
      y: 141,
      width: 152,
      fillColor: "lime0",
      strokeColor: "lime4",
      text: "Design Tools",
      hoverColor: "lime1",
    },
    {
      type: "secondaryBox",
      x: 289,
      y: 220,
      width: 152,
      fillColor: "lime0",
      strokeColor: "lime4",
      text: "Design Systems",
      hoverColor: "lime1",
    },
    {
      type: "secondaryBox",
      x: 289,
      y: 294,
      width: 152,
      fillColor: "lime0",
      strokeColor: "lime4",
      text: "Atomic Design",
      hoverColor: "lime1",
    },
  ],
};
